import React, { useState } from 'react';
import { MarketPulse } from './MarketPulse';
import { QuickTips } from './QuickTips';
import appsIcon from '@/assets/apps-outline.svg';

const MARKET_PULSE_ICON_URL = 'https://storage.googleapis.com/rev-public/icons/Market%20Pulse.svg';
const QUICK_TIPS_ICON_URL = 'https://storage.googleapis.com/rev-public/icons/Quick%20Tips.svg';

interface RightSidebarProps {
  className?: string;
}

export const RightSidebar: React.FC<RightSidebarProps> = ({ className }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      {/* Backdrop for mobile/tablet drawer */}
      {isExpanded && (
        <div
          className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40 lg:hidden"
          onClick={() => setIsExpanded(false)}
        />
      )}

      <aside className={`w-full md:w-14 lg:w-[27%] lg:max-w-[358px] transition-all duration-300 shrink-0 md:border-l md:border-gray-200 ${className || ''}`}>
        {/* Collapsed view - icon only (visible below LG) */}
        <div className="lg:hidden flex flex-col items-center p-2.5 h-full border-l border-gray-100 md:border-none gap-4">
          <button
            onClick={() => setIsExpanded(true)}
            className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Open sidebar"
          >
            <img src={appsIcon} alt="Apps" className="w-6 h-6 text-gray-600" />
          </button>
          <button
            onClick={() => setIsExpanded(true)}
            className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Open sidebar to Market Pulse"
          >
            <img src={MARKET_PULSE_ICON_URL} alt="Market Pulse" className="w-6 h-6 object-contain" />
          </button>
          <button
            onClick={() => setIsExpanded(true)}
            className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Open sidebar to Quick Tips"
          >
            <img src={QUICK_TIPS_ICON_URL} alt="Quick Tips" className="w-6 h-6 object-contain" />
          </button>
        </div>

        {/* Drawer Content (Fixed on < LG, Static on LG) */}
        <div className={`
          bg-gray-50 fixed top-0 right-0 h-full w-[320px] z-50 shadow-2xl transition-transform duration-300 ease-in-out
          lg:static lg:h-auto lg:w-full lg:shadow-none lg:transform-none lg:z-auto
          ${isExpanded ? 'translate-x-0' : 'translate-x-full lg:translate-x-0'}
        `}>
          <div className="h-full overflow-y-auto">
            {/* Mobile Close Button */}
            <div className="lg:hidden p-2 flex justify-end">
              <button
                onClick={() => setIsExpanded(false)}
                className="p-1 hover:bg-gray-100 rounded-full"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="flex items-start gap-2.5 p-2.5">
              <div className="self-stretch w-full my-auto flex flex-col gap-2.5">
                <div className="flex w-full items-stretch gap-2.5">
                  <MarketPulse />
                </div>
                <div className="flex w-full items-stretch gap-2.5">
                  <QuickTips />
                </div>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};
